export default {
  title: 'Activar MAXHUB',
  instruction: 'Rellene correctamente la información de usuario y vendedor, puede afectar a problemas relacionados con el servicio postventa ',
  dealername: 'Nombre del vendedor',
  dealerplaceholder: 'Nombre del vendedor',
  companyname: 'Nombre de la empresa',
  companyplaceholder: 'Nombre de la empresa',
  tele: 'Información de contacto',
  teleplaceholder: 'Teléfono móvil',
  district: 'Seleccionar área',
  distplaceholder: 'Información de área',
  address: 'Dirección detallada',
  addrplaceholder: 'Dirección detallada',
  activebtn: 'Obtener el código de activación',
  confirmbtn: 'Confirmar',
  cancelbtn: 'Cancelar',
  dialogmessage: 'El formato del teléfono móvil es incorrecto, vuelva a introducirlo',
  dialogbtn: 'Confirmar',
  errortitle: 'No se puede abrir',
  errorinfo1: 'Pruebe a comprobar la red',
  errorinfo2: 'Línea de asistencia 400-168-9545',
  nosn: 'Este dispositivo no puede activarse porque no hay NS',
  activepagetitle: 'Código de activación',
  activepagehint: 'Introduzca el código de activación para activar el dispositivo',
  finish: 'Terminar',
  search: 'Búsquenlo cerca'
};



// WEBPACK FOOTER //
// ./src/i18n/_es.js